const FILESTACK_API_KEY = import.meta.env.VITE_FILESTACK_API_KEY

export default FILESTACK_API_KEY
